import ProblemStatement from 'business/organizer/library/pages/question-create-update/file-upload/steps/ProblemStatement';
import React from 'react';

const RenderFileUploadStep = () => {
    return <ProblemStatement />
};

export default RenderFileUploadStep;
